module.exports = __webpack_public_path__ + "img/ai_speaking_jp.80cbeaa6.png";